// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*소견서 작성하기 팝업*/
.CreateOpinionPopup_create_opinion_pop__jeBEf{
    position: absolute;
    width: 700px;
    height: 730px;
    border-radius: 20px;
    background: #FFF;
    box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);
    padding: 17px 20px; box-sizing: border-box;
    z-index: 9999;
    display: block;
}

.CreateOpinionPopup_create_opinion_pop__jeBEf .CreateOpinionPopup_tit__7DWNf{
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 15px;
    display: flex;
}

.CreateOpinionPopup_create_opinion_pop__jeBEf .CreateOpinionPopup_tit__7DWNf .CreateOpinionPopup_close_btn__x-GVz{margin-left: auto;cursor: pointer;}
.CreateOpinionPopup_create_opinion_pop__jeBEf .CreateOpinionPopup_tit__7DWNf .CreateOpinionPopup_close_btn__x-GVz svg{position: relative; top: 2px;}
.CreateOpinionPopup_create_opinion_pop__jeBEf .CreateOpinionPopup_tit__7DWNf .CreateOpinionPopup_title__b6sIB{font-size:20px;color: black;}

.CreateOpinionPopup_create_opinion_pop__jeBEf .CreateOpinionPopup_section__r-TXo {
    display:flex;
    min-height:600px;
    max-height: 600px;
    flex-direction: column;
    overflow-x:hidden;
    overflow-y:auto;
    align-items: center;
    margin: 15px 0;
}

.CreateOpinionPopup_section__r-TXo .CreateOpinionPopup_column__IvHrE{
    display:flex;
    width:100%;
    white-space: pre-wrap;
    word-wrap: break-word; 
}

.CreateOpinionPopup_column__IvHrE > div {
    padding: 10px 20px;
}

.CreateOpinionPopup_column__IvHrE .CreateOpinionPopup_title__b6sIB {
    background-color: rgba(90, 90, 90, 0.09);
    min-width: 117px;
    border: 1px solid #E8E8E8;
}

.CreateOpinionPopup_column__IvHrE .CreateOpinionPopup_obj__eTOwG {
    width: 100%;
    border: 1px solid #E8E8E8;
    font-size: 14px;
}

.CreateOpinionPopup_column__IvHrE .CreateOpinionPopup_boldText__NNIov {
    font-weight: bold;
}

.CreateOpinionPopup_column__IvHrE .CreateOpinionPopup_obj__eTOwG .CreateOpinionPopup_input_text__zx7pt {
    width: 100%;
    min-height: 150px;
    resize: none;
    border: 0;
    margin:0;
    padding:0;
    font-size:14px;
}

.CreateOpinionPopup_create_opinion_pop__jeBEf .CreateOpinionPopup_send__oLVan {
    width: 100%;
    display:flex;
    text-align: center;
    align-items: center;
    justify-content: space-between;
    margin-top:20px;
}

.CreateOpinionPopup_send__oLVan button.CreateOpinionPopup_black__r0oxf {
    width: 110px;
    height: 38px;
    background: #3E3F3F;
    color: #FFFFFF;
    font-size:18px;
    font-weight: 300;
    border-radius: 5px;
    border: none;
}

.CreateOpinionPopup_send__oLVan button.CreateOpinionPopup_colored__90xru {
    width: 110px;
    height: 38px;
    background: #51D7DF;
    color: #FFFFFF;
    font-size:18px;
    font-weight: 300;
    border-radius: 5px;
    border: none;
}`, "",{"version":3,"sources":["webpack://./src/components/CreateOpinionPopup.module.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAER,gDAAgD;IACxD,kBAAkB,EAAkC,sBAAsB;IAC1E,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IAGnB,aAAa;AACjB;;AAEA,kHAAoC,iBAAiB,CAAC,eAAe,CAAC;AACtE,sHAAwC,kBAAkB,EAAE,QAAQ,CAAC;AACrE,8GAAgC,cAAc,CAAC,YAAY,CAAC;;AAE5D;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB","sourcesContent":["/*소견서 작성하기 팝업*/\n.create_opinion_pop{\n    position: absolute;\n    width: 700px;\n    height: 730px;\n    border-radius: 20px;\n    background: #FFF;\n    -webkit-box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);\n            box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);\n    padding: 17px 20px; -webkit-box-sizing: border-box; box-sizing: border-box;\n    z-index: 9999;\n    display: block;\n}\n\n.create_opinion_pop .tit{\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 15px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.create_opinion_pop .tit .close_btn{margin-left: auto;cursor: pointer;}\n.create_opinion_pop .tit .close_btn svg{position: relative; top: 2px;}\n.create_opinion_pop .tit .title{font-size:20px;color: black;}\n\n.create_opinion_pop .section {\n    display:flex;\n    min-height:600px;\n    max-height: 600px;\n    flex-direction: column;\n    overflow-x:hidden;\n    overflow-y:auto;\n    align-items: center;\n    margin: 15px 0;\n}\n\n.section .column{\n    display:flex;\n    width:100%;\n    white-space: pre-wrap;\n    word-wrap: break-word; \n}\n\n.column > div {\n    padding: 10px 20px;\n}\n\n.column .title {\n    background-color: rgba(90, 90, 90, 0.09);\n    min-width: 117px;\n    border: 1px solid #E8E8E8;\n}\n\n.column .obj {\n    width: 100%;\n    border: 1px solid #E8E8E8;\n    font-size: 14px;\n}\n\n.column .boldText {\n    font-weight: bold;\n}\n\n.column .obj .input_text {\n    width: 100%;\n    min-height: 150px;\n    resize: none;\n    border: 0;\n    margin:0;\n    padding:0;\n    font-size:14px;\n}\n\n.create_opinion_pop .send {\n    width: 100%;\n    display:flex;\n    text-align: center;\n    align-items: center;\n    justify-content: space-between;\n    margin-top:20px;\n}\n\n.send button.black {\n    width: 110px;\n    height: 38px;\n    background: #3E3F3F;\n    color: #FFFFFF;\n    font-size:18px;\n    font-weight: 300;\n    border-radius: 5px;\n    border: none;\n}\n\n.send button.colored {\n    width: 110px;\n    height: 38px;\n    background: #51D7DF;\n    color: #FFFFFF;\n    font-size:18px;\n    font-weight: 300;\n    border-radius: 5px;\n    border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"create_opinion_pop": `CreateOpinionPopup_create_opinion_pop__jeBEf`,
	"tit": `CreateOpinionPopup_tit__7DWNf`,
	"close_btn": `CreateOpinionPopup_close_btn__x-GVz`,
	"title": `CreateOpinionPopup_title__b6sIB`,
	"section": `CreateOpinionPopup_section__r-TXo`,
	"column": `CreateOpinionPopup_column__IvHrE`,
	"obj": `CreateOpinionPopup_obj__eTOwG`,
	"boldText": `CreateOpinionPopup_boldText__NNIov`,
	"input_text": `CreateOpinionPopup_input_text__zx7pt`,
	"send": `CreateOpinionPopup_send__oLVan`,
	"black": `CreateOpinionPopup_black__r0oxf`,
	"colored": `CreateOpinionPopup_colored__90xru`
};
export default ___CSS_LOADER_EXPORT___;
